// Rules and wording shared by the Share Property pages
// (app/screens/ShareProperty/*).

export const SHARE_PATHS = {
  HOME: "/share-property",
  USER: "/share-property/user",
};

export const ROLE_OPTIONS = [
  { value: "owner", label: "Owner" },
  { value: "guest", label: "Guest" },
];

// "Choose what to share": the devices picked on Select Devices, or all of them.
export const SHARE_OPTIONS = [
  { value: "some", label: "Choose Devices" },
  { value: "all", label: "Every Device" },
];

// As in the app, a person is only looked up once a whole email address is typed.
export const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// With nothing to list, the server answers { msg, status: 404 } instead of an
// empty list (PermissionService.getSharedUsersByProperty).
export const asList = (response) => (Array.isArray(response) ? response : []);

export const roleLabel = (role) => ROLE_OPTIONS.find((option) => option.value === role)?.label ?? role ?? "";

export const initialOf = (text) => (text ? text.trim().charAt(0).toUpperCase() : "?");

// A search result is a HASHh account: username, email, first and last name.
export const personName = (person) => [person.firstName, person.lastName].filter(Boolean).join(" ");

export const personInitials = (person) =>
  `${person.firstName?.charAt(0) ?? ""}${person.lastName?.charAt(0) ?? ""}`.toUpperCase() ||
  initialOf(person.username ?? person.email);

const count = (number, word) => `${number} ${word}${number === 1 ? "" : "s"}`;

export const devicesLabel = (number) => count(number, "Device");

// What one share covers, for the Shared Users list.
export const shareSummary = (share) =>
  share.shareAll ? "Every device" : count(share.devices?.length ?? 0, "device");

// Whether a share's devices go to Google Home or Alexa (shareWithGoogle,
// shareWithAlexa). Shares saved before the switches existed count as on, as
// in the API.
export const voiceOn = (value) => value !== false;

// The app's line under each person on the Shared Users list.
export const voiceSummary = (share) =>
  `Google Home: ${voiceOn(share.shareWithGoogle) ? "On" : "Off"} · Alexa: ${voiceOn(share.shareWithAlexa) ? "On" : "Off"}`;

// The app's "Shared successfully!" message.
export const sharedMessage = (shareAll, deviceCount, who) =>
  shareAll
    ? `You have shared "Every Device" in the property with "${who}".`
    : `You have shared "${devicesLabel(deviceCount)}" with "${who}".`;

// True when both lists hold the same device ids, in any order.
export const sameDevices = (a = [], b = []) => {
  const left = new Set(a.map(String));
  const right = new Set(b.map(String));
  return left.size === right.size && [...left].every((id) => right.has(id));
};
